import { render, staticRenderFns } from "./PublisherDeleteModal.vue?vue&type=template&id=16508123"
import script from "./PublisherDeleteModal.vue?vue&type=script&lang=js"
export * from "./PublisherDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports